import * as ActionTypes from '../constants/ActionTypes';
import { ActionCreator } from '../utils/flux';

/**
 * @class TimesGridActions
 * @extends ActionCreator
 */
export default class TimesGridActions extends ActionCreator {
    changeGridType(isMobile) {
        this.dispatch({
            actionType: ActionTypes.CHANGE_GRID_TYPE,
            isMobile,
        });
    }

    /**
     * @param {int} numDaysVisible
     */
    changeNumDaysVisible(numDaysVisible) {
        this.dispatch({
            actionType: ActionTypes.CHANGE_NUM_DAYS_VISIBLE,
            numDaysVisible,
        });
    }

    clickMoreTimes() {
        this.dispatch({
            actionType: ActionTypes.CLICK_MORE_TIMES,
        });
    }

    clickNextDays() {
        this.dispatch({
            actionType: ActionTypes.CLICK_NEXT_DAYS,
        });
    }

    clickPrevDays() {
        this.dispatch({
            actionType: ActionTypes.CLICK_PREV_DAYS,
        });
    }

    /**
     * @param {moment} date
     */
    jumpToDate(date, guid, key) {
        this.dispatch({
            actionType: ActionTypes.JUMP_TO_DATE,
            date,
            guid,
            key,
        });
    }

    /**
     * @param {Event} event
     * @param {object} timeslot
     */
    showConstraint(event, timeslot) {
        this.dispatch({
            actionType: ActionTypes.SHOW_CONSTRAINT,
            event,
            timeslot,
        });
    }
}
